import Vue from 'vue'
import NavigationSection from '@/components/Navigation/NavigationSection.vue'
import BlockAcceptMessage from '@/components/AcceptMessage/BlockAcceptMessage.vue'
import BlockAcceptMessageStudent from '@/components/AcceptMessage/BlockAcceptMessageStudent.vue'
import BlockAcceptMessageStudentEng from '@/components/AcceptMessage/BlockAcceptMessageStudentEng.vue'

Vue.component('NavigationSection', NavigationSection)

Vue.component('BlockAcceptMessage', BlockAcceptMessage)
Vue.component('BlockAcceptMessageStudent', BlockAcceptMessageStudent)
Vue.component('BlockAcceptMessageStudentEng', BlockAcceptMessageStudentEng)
